var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5016 4.72656C10.4578 4.72656 4.72656 10.4578 4.72656 17.5016C4.72656 24.5453 10.4578 30.2766 17.5016 30.2766C24.5453 30.2766 30.2766 24.5453 30.2766 17.5016C30.2766 10.4578 24.5453 4.72656 17.5016 4.72656ZM17.5016 28.625C11.3656 28.625 6.36719 23.6375 6.36719 17.4906C6.36719 11.3438 11.3656 6.36719 17.5016 6.36719C23.6375 6.36719 28.6359 11.3547 28.6359 17.5016C28.6359 23.6484 23.6484 28.6359 17.5016 28.6359V28.625Z",
    fill: "#00A200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5594 14.5898H16.4375V24.3898H18.5594V14.5898Z",
    fill: "#00A200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5006 10.388L16.0234 11.8652L17.5006 13.3424L18.9778 11.8652L17.5006 10.388Z",
    fill: "#00A200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dba908f3b9dd35db6a887c8d54b43263.svg";
export { ForwardRef as ReactComponent };